// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedCurrency from "@insite/content-library/Components/LocalizedCurrency";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    total: state.pages.quickOrder.total,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface QuickOrderTotalStyles {
    wrapper?: InjectableCss;
    totalWrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    totalLabel?: TypographyPresentationProps;
    totalValue?: TypographyPresentationProps;
    buttonsWrapper?: InjectableCss;
}

export const quickOrderTotalStyles: QuickOrderTotalStyles = {};

const styles = quickOrderTotalStyles;

const QuickOrderTotal: FC<Props> = ({ total, id }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.title} as="h2">
                {translate("Quick Order Summary")}
            </Typography>
            <StyledWrapper {...styles.totalWrapper}>
                <Typography {...styles.totalLabel}>{translate("Subtotal")}</Typography>
                <Typography {...styles.totalValue}>
                    <LocalizedCurrency amount={total} />
                </Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.buttonsWrapper}>
                {createWidgetElement("QuickOrder/QuickOrderActions", {
                    fields: { showAddAllProductsToList: true, showAddAllProductsToCart: true },
                })}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(QuickOrderTotal),
    definition: {
        allowedContexts: ["QuickOrderPage"],
        group: "Quick Order",
    },
};

export default widgetModule;
